export const ARRAY = 5
export const ASSIGN = 6
export const BINARY = 7
export const CALL = 8
export const CONDITION = 9
export const IDENTIFIER = 2
export const LITERAL = 3
export const MEMBER = 10
export const OBJECT = 11
export const PROPERTY = 4
export const SEQUENCE = 12
export const UNARY = 13
export const UPDATE = 14

export default {
  ARRAY,
  ASSIGN,
  BINARY,
  CALL,
  CONDITION,
  IDENTIFIER,
  LITERAL,
  MEMBER,
  OBJECT,
  PROPERTY,
  SEQUENCE,
  UNARY,
  UPDATE,
}
